import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Feature flag for ODM order creation ADT
 */
@Injectable()
export class OdmOrderCreationBlkAdt implements IFlagFeature {
  name = Features.ODM_ORDER_CREATION_BLK_ADT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
